import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useRive } from '@rive-app/react-canvas';
import { checkSeasonsRoomTypeDiff, deepCopy } from "../../../app/util";
import {
    Box,
    Button,
} from "@mui/material/";

const MissingDifferentialScreen = (props) => {
    const { app, auth } = useSelector((state) => state);
    const { user, profile } = auth;
    const { app_state, ui_state } = app.current_state;
    const { property_details } = profile || [];
    const dispatch = useDispatch();

    let system_settings = {};
    try {
        system_settings = property_details.filter(
            (item) => item.id === app_state.property_id
        )[0].system_settings[0];
    } catch (error) {
        console.error("room_types can not be resoved");
    }

    let room_dow_plans = system_settings?.pricing_settings?.room_dow_plans;
    const isSeasonConfigured = Boolean(room_dow_plans?.length && room_dow_plans[0].status && room_dow_plans[0].pricingModel == 3);
    let isRoomTypeDifference = checkSeasonsRoomTypeDiff(room_dow_plans, ['active'], 3);

    let popupText = "";
    let popupHeadText = "";
    if (isRoomTypeDifference) {
        // popupText = "Your New Room Types Don't Have Differentials in Active Pricing Seasons. Add Them to Enable Rate Push.";
        // popupHeadText = "Update Required for New Room Types";
        popupText = "Min Max Guardrails for the New Room Types Are Missing in Your Pricing Seasons. \n Please Update All Active Seasons to Enable Auto Rate Push.";
        popupHeadText = "Missing Guardrails in Pricing Season";
    }
    if (!isSeasonConfigured) {
        // popupText = " Differentials for the New Room Types Are Missing in Your Pricing Seasons. Please Update All Active Seasons to Enable Auto Rate Push."
        popupText = "Create a Pricing Season to Unlock Rate Recommendations, Enable Auto Rate Push, and Activate Pricing."
        popupHeadText = "Set Up a Pricing Season";
    }

    const handleClickUpdateNow = () => {
        ui_state.isFromHeader = false;
        ui_state.active_settings_menu = "propertySettingsMenu"
        ui_state.activeSettingsComponentName = "DefaultRoomTypePricing"
        ui_state.settingsActiveIndex = 12;

        dispatch({
            type: "UPDATE_STATE",
            payload: {
                ui_state: deepCopy(ui_state)
            },
        });
    }

    function PricingSeasonsIcon() {
        const { rive, RiveComponent } = useRive({
            src: 'assets/rive/pricing_seasons.riv',
            stateMachines: "State Machine 1",
            autoplay: true,
        });

        return (
            <RiveComponent />
        );
    }

    return (
        <Box
            className="auto-ratepush-missing-differentials"
            sx={{
                height: "70vh", // full height of viewport
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
            }}
        >
            {/* Image */}
            <div className='empty-screen-icon'>
                <PricingSeasonsIcon />
            </div>
            {/* Text */}
            <div>
                <Box className='h3-title' sx={{ mb: 0.5 }}>{popupHeadText}</Box>
                <Box className='p-text' sx={{ mb: 2 }}>{popupText}</Box>
                <Button onClick={handleClickUpdateNow} className="button">{(!isSeasonConfigured) ? "Configure Now" : "Update Now"}</Button>
            </div>
        </Box>
    )
}

export default MissingDifferentialScreen